import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/DashboardLayout';
import BarberOverview from './views/BarberOverview';
import BarberSettings from './views/BarberSettings';
import BarberBookings from './views/BarberBookings';
import BarberAvailability from './views/BarberAvailability';
import BarberServices from './views/BarberServices';
import BarberEarnings from './views/BarberEarnings';
import BarberSchedule from './views/BarberSchedule';

const navigation = [
  { name: 'Dashboard', icon: 'Home', path: '/barber/dashboard' },
  { name: 'Schedule', icon: 'Calendar', path: '/barber/schedule' },
  { name: 'Bookings', icon: 'List', path: '/barber/bookings' },
  { name: 'Availability', icon: 'Clock', path: '/barber/availability' },
  { name: 'Services', icon: 'Briefcase', path: '/barber/services' },
  { name: 'Earnings', icon: 'DollarSign', path: '/barber/earnings' },
  { name: 'Settings', icon: 'Settings', path: '/barber/settings' },
];

export default function BarberDashboard() {
  return (
    <DashboardLayout role="barber" navigation={navigation}>
      <Routes>
        <Route path="dashboard" element={<BarberOverview />} />
        <Route path="schedule" element={<BarberSchedule />} />
        <Route path="bookings" element={<BarberBookings />} />
        <Route path="availability" element={<BarberAvailability />} />
        <Route path="services" element={<BarberServices />} />
        <Route path="earnings" element={<BarberEarnings />} />
        <Route path="settings" element={<BarberSettings />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  );
}